module.exports = __webpack_public_path__ + "static/img/grda01.5d286571.png";